import React from 'react';
import { Icon } from 'semantic-ui-react'

import TagsDropdown from './tag_components/tags_dropdown';

import { stopEventPropagation } from '../../helpers/event_helpers';


export default function TrainingCountries(props) {
  const { countryList, countryOptions, updateCountries, removeCountry, updateTraining, canUpdate } = props;

  return (
    <div className="training-country" onClick={stopEventPropagation}>
      {
        canUpdate
        ?
        <TagsDropdown
          className="tags-dropdown"
          trigger={<span className="link country-theme">Country: </span>}
          header="Assign country:"
          tagList={countryList}
          onApply={updateCountries}
          tagOptions={countryOptions}
          searchable={true}
          searchPlaceholder="Search countries"
          newPlaceholder="Enter new country"
          onDone={updateTraining}
        />
        :
        <span className="country-theme">Country: </span>
      }
      <span className='training-countries country-theme'>
        {
          countryList.map((country, index)=>{
            return (
              <span className='country' key={country} value={country}>
                {country} { canUpdate && <Icon name='close' className='country-theme' value={country} onClick={() => removeCountry(country)}/>}
                {
                  index !== countryList.length - 1 && <span> , </span>
                }
              </span>
            )
          })
        }
      </span>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/training_countries.js